import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "o-brokerSearchList" }
const _hoisted_2 = { class: "o-brokerSearchList__filters" }
const _hoisted_3 = { class: "u-container" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 0,
  class: "u-container"
}
const _hoisted_6 = { class: "o-brokerSearchList__grid" }
const _hoisted_7 = {
  key: 1,
  class: "u-container"
}
const _hoisted_8 = { class: "u-row" }
const _hoisted_9 = { class: "u-col-12" }
const _hoisted_10 = { class: "o-brokerSearchList__noResults" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "o-buttons" }
const _hoisted_13 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_loader = _resolveComponent("m-loader")!
  const _component_o_broker_map_card = _resolveComponent("o-broker-map-card")!
  const _component_o_broker_preview = _resolveComponent("o-broker-preview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "a-label",
          textContent: _toDisplayString($options.countText)
        }, null, 8 /* PROPS */, _hoisted_4)
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_m_loader, { key: 0 }))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }),
    (!_ctx.isLoading && _ctx.brokers.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            ($options.isMobile)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.brokers, (broker) => {
                  return (_openBlock(), _createBlock(_component_o_broker_map_card, {
                    key: broker.properties.data.brokerId,
                    class: _normalizeClass(["o-brokerSearchList__brokerPreview", {
                                isActive:
                                    broker.properties.data.brokerId ===
                                    _ctx.activeBroker,
                            }]),
                    data: broker.properties.data
                  }, null, 8 /* PROPS */, ["class", "data"]))
                }), 128 /* KEYED_FRAGMENT */))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.brokers, (broker) => {
                  return (_openBlock(), _createBlock(_component_o_broker_preview, {
                    key: broker.properties.data.brokerId,
                    "data-id": broker.properties.data.brokerId,
                    class: _normalizeClass(["o-brokerSearchList__brokerPreview", {
                                isActive:
                                    broker.properties.data.brokerId ===
                                    _ctx.activeBroker,
                            }]),
                    broker: broker.properties.data
                  }, null, 8 /* PROPS */, ["data-id", "class", "broker"]))
                }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createCommentVNode(" <div class=\"u-row\">\n                    <div class=\"u-col-12 a-anchor o-brokerSearchList__brokerLinks\">\n                        <a :href=\"texts.brokerLinksUrl\" v-text=\"texts.brokerLinksText\" />\n                    </div>\n                </div> ")
        ]))
      : _createCommentVNode("v-if", true),
    (!_ctx.isLoading && _ctx.brokers.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h2", {
                  class: "a-heading2 o-brokerSearchList__noResultsTitle",
                  textContent: _toDisplayString($props.texts.noResultsHeading)
                }, null, 8 /* PROPS */, _hoisted_11),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "m-button m-button--outlined",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.zoomOutAndReset()))
                  }, [
                    _createElementVNode("span", {
                      class: "m-button__text",
                      textContent: _toDisplayString($props.texts.resetButtonText)
                    }, null, 8 /* PROPS */, _hoisted_13)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}